import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { useTranslation } from 'react-i18next';

const OrderStatusChart = ({ data }) => {
    const { t } = useTranslation();
    const strings = t('dashboard.charts.orderStatus', { returnObjects: true });

    const STATUS_CONFIG = {
        pending:    { label: strings.statuses.pending,    color: '#f59e0b' },
        in_transit: { label: strings.statuses.in_transit, color: '#3b82f6' },
        loading:    { label: strings.statuses.loading,    color: '#8b5cf6' },
        loaded:     { label: strings.statuses.loaded,     color: '#06b6d4' },
        invoiced:   { label: strings.statuses.invoiced,   color: '#10b981' },
    };

    if (!data || data.length === 0) return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <span style={titleStyle}>{strings.titleShort}</span>
            </div>
            <div style={{ padding: '40px 0', textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>{strings.noData}</div>
        </div>
    );

    const total = data.reduce((s, d) => s + d.count, 0);
    const pieData = data.map((item, i) => {
        const cfg = STATUS_CONFIG[item.status] || { label: item.status, color: '#9ca3af' };
        return { id: i, value: item.count, label: cfg.label, color: cfg.color };
    });

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.titleBreakdown}</span>
                    <div style={subtitleStyle}>{t('dashboard.charts.orderStatus.totalOrders', { count: total })}</div>
                </div>
            </div>

            {/* Pie chart centered */}
            <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 20px 4px' }}>
                <PieChart
                    series={[{
                        data: pieData,
                        innerRadius: '52%',
                        paddingAngle: 2,
                        cornerRadius: 4,
                        arcLabel: null,
                        highlightScope: { faded: 'global', highlighted: 'item' },
                    }]}
                    slotProps={{ legend: { hidden: true } }}
                    margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                    width={220}
                    height={220}
                />
            </div>

            {/* Custom legend rows */}
            <div style={{ padding: '4px 20px 20px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                {data.map((item) => {
                    const cfg = STATUS_CONFIG[item.status] || { label: item.status, color: '#9ca3af' };
                    return (
                        <div key={item.status} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 10px', borderRadius: 8, backgroundColor: '#f9fafb' }}>
                            <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: cfg.color, flexShrink: 0 }} />
                            <span style={{ fontSize: 13, color: '#374151', flex: 1, fontWeight: 500 }}>{cfg.label}</span>
                            <span style={{ fontSize: 14, fontWeight: 700, color: '#111827', minWidth: 24, textAlign: 'right' }}>{item.count}</span>
                            <span style={{
                                fontSize: 11, fontWeight: 600, color: cfg.color,
                                backgroundColor: `${cfg.color}20`, borderRadius: 12,
                                padding: '2px 8px', minWidth: 40, textAlign: 'center'
                            }}>
                                {item.percentage?.toFixed(0)}%
                            </span>
                            <span style={{ fontSize: 11, color: '#9ca3af', minWidth: 80, textAlign: 'right' }}>
                                {parseFloat(item.total_weight_tons || 0).toFixed(2)} {strings.tonSuffix}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const cardStyle = {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    border: '1px solid #f3f4f6',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    height: '100%',
};
const headerStyle = {
    padding: '18px 20px 14px',
    borderBottom: '1px solid #f9fafb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
};
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };

export default OrderStatusChart;
